/* Reconstructed from tenant.zip:public/build/assets/vuex.esm-bundler-DJRHx7fM.js
 * Original SHA-256: bb676facf5158feca38aab00f03535f4fb24a78a4f57b6d0ec8dc324a16b0e78
 * Surviving compiled logic, formatted and relinked. Original templates/comments/names are not recovered.
 */
import { ht as e, j as t, lt as n, rt as r, t as i, v as a } from "./vue.esm-bundler-B5vgcGJL.js";
i();
function o() {
  return s().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function s() {
  return typeof navigator < `u` && typeof window < `u`
    ? window
    : typeof globalThis < `u`
      ? globalThis
      : {};
}
var c = typeof Proxy == `function`,
  l = `devtools-plugin:setup`,
  u = `plugin:settings:set`,
  d,
  f;
function p() {
  return (
    d === void 0 &&
      (typeof window < `u` && window.performance
        ? ((d = !0), (f = window.performance))
        : typeof globalThis < `u` && globalThis.perf_hooks?.performance
          ? ((d = !0), (f = globalThis.perf_hooks.performance))
          : (d = !1)),
    d
  );
}
function m() {
  return p() ? f.now() : Date.now();
}
var h = class {
  constructor(e, t) {
    ((this.target = null),
      (this.targetQueue = []),
      (this.onQueue = []),
      (this.plugin = e),
      (this.hook = t));
    let n = {};
    if (e.settings) for (let t in e.settings) n[t] = e.settings[t].defaultValue;
    let r = `__vue-devtools-plugin-settings__${e.id}`,
      i = Object.assign({}, n);
    try {
      let e = localStorage.getItem(r),
        t = JSON.parse(e);
      Object.assign(i, t);
    } catch {}
    ((this.fallbacks = {
      getSettings() {
        return i;
      },
      setSettings(e) {
        try {
          localStorage.setItem(r, JSON.stringify(e));
        } catch {}
        i = e;
      },
      now() {
        return m();
      },
    }),
      t &&
        t.on(u, (e, t) => {
          e === this.plugin.id && this.fallbacks.setSettings(t);
        }),
      (this.proxiedOn = new Proxy(
        {},
        {
          get: (e, t) =>
            this.target
              ? this.target.on[t]
              : (...e) => {
                  this.onQueue.push({
                    method: t,
                    args: e,
                  });
                },
        },
      )),
      (this.proxiedTarget = new Proxy(
        {},
        {
          get: (e, t) =>
            this.target
              ? this.target[t]
              : t === `on`
                ? this.proxiedOn
                : Object.keys(this.fallbacks).includes(t)
                  ? (...e) => (
                      this.targetQueue.push({
                        method: t,
                        args: e,
                        resolve: () => {},
                      }),
                      this.fallbacks[t](...e)
                    )
                  : (...e) =>
                      new Promise((n) => {
                        this.targetQueue.push({
                          method: t,
                          args: e,
                          resolve: n,
                        });
                      }),
        },
      )));
  }
  async setRealTarget(e) {
    this.target = e;
    for (let e of this.onQueue) this.target.on[e.method](...e.args);
    for (let e of this.targetQueue) e.resolve(await this.target[e.method](...e.args));
  }
};
function g(e, t) {
  let n = e,
    r = s(),
    i = o(),
    a = c && n.enableEarlyProxy;
  if (i && (r.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !a)) i.emit(l, e, t);
  else {
    let e = a ? new h(n, i) : null;
    ((r.__VUE_DEVTOOLS_PLUGINS__ = r.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: t,
      proxy: e,
    }),
      e && t(e.proxiedTarget));
  }
}
var _ = `store`;
function ee(e) {
  return (e === void 0 && (e = null), t(e === null ? _ : e));
}
function v(e, t) {
  Object.keys(e).forEach(function (n) {
    return t(e[n], n);
  });
}
function y(e) {
  return typeof e == `object` && !!e;
}
function te(e) {
  return e && typeof e.then == `function`;
}
function b(e, t) {
  return function () {
    return e(t);
  };
}
function x(e, t, n) {
  return (
    t.indexOf(e) < 0 && (n && n.prepend ? t.unshift(e) : t.push(e)),
    function () {
      var n = t.indexOf(e);
      n > -1 && t.splice(n, 1);
    }
  );
}
function S(e, t) {
  ((e._actions = Object.create(null)),
    (e._mutations = Object.create(null)),
    (e._wrappedGetters = Object.create(null)),
    (e._modulesNamespaceMap = Object.create(null)));
  var n = e.state;
  (w(e, n, [], e._modules.root, !0), C(e, n, t));
}
function C(t, r, i) {
  var o = t._state,
    s = t._scope;
  ((t.getters = {}), (t._makeLocalGettersCache = Object.create(null)));
  var c = t._wrappedGetters,
    l = {},
    u = {},
    d = n(!0);
  (d.run(function () {
    v(c, function (e, n) {
      ((l[n] = b(e, t)),
        (u[n] = a(function () {
          return l[n]();
        })),
        Object.defineProperty(t.getters, n, {
          get: function () {
            return u[n].value;
          },
          enumerable: !0,
        }));
    });
  }),
    (t._state = e({
      data: r,
    })),
    (t._scope = d),
    t.strict && A(t),
    o &&
      i &&
      t._withCommit(function () {
        o.data = null;
      }),
    s && s.stop());
}
function w(e, t, n, r, i) {
  var a = !n.length,
    o = e._modules.getNamespace(n);
  if ((r.namespaced && (e._modulesNamespaceMap[o], (e._modulesNamespaceMap[o] = r)), !a && !i)) {
    var s = j(t, n.slice(0, -1)),
      c = n[n.length - 1];
    e._withCommit(function () {
      s[c] = r.state;
    });
  }
  var l = (r.context = T(e, o, n));
  (r.forEachMutation(function (t, n) {
    D(e, o + n, t, l);
  }),
    r.forEachAction(function (t, n) {
      O(e, t.root ? n : o + n, t.handler || t, l);
    }),
    r.forEachGetter(function (t, n) {
      k(e, o + n, t, l);
    }),
    r.forEachChild(function (r, a) {
      w(e, t, n.concat(a), r, i);
    }));
}
function T(e, t, n) {
  var r = t === ``,
    i = {
      dispatch: r
        ? e.dispatch
        : function (n, r, i) {
            var a = M(n, r, i),
              o = a.payload,
              s = a.options,
              c = a.type;
            return ((!s || !s.root) && (c = t + c), e.dispatch(c, o));
          },
      commit: r
        ? e.commit
        : function (n, r, i) {
            var a = M(n, r, i),
              o = a.payload,
              s = a.options,
              c = a.type;
            ((!s || !s.root) && (c = t + c), e.commit(c, o, s));
          },
    };
  return (
    Object.defineProperties(i, {
      getters: {
        get: r
          ? function () {
              return e.getters;
            }
          : function () {
              return E(e, t);
            },
      },
      state: {
        get: function () {
          return j(e.state, n);
        },
      },
    }),
    i
  );
}
function E(e, t) {
  if (!e._makeLocalGettersCache[t]) {
    var n = {},
      r = t.length;
    (Object.keys(e.getters).forEach(function (i) {
      if (i.slice(0, r) === t) {
        var a = i.slice(r);
        Object.defineProperty(n, a, {
          get: function () {
            return e.getters[i];
          },
          enumerable: !0,
        });
      }
    }),
      (e._makeLocalGettersCache[t] = n));
  }
  return e._makeLocalGettersCache[t];
}
function D(e, t, n, r) {
  (e._mutations[t] || (e._mutations[t] = [])).push(function (t) {
    n.call(e, r.state, t);
  });
}
function O(e, t, n, r) {
  (e._actions[t] || (e._actions[t] = [])).push(function (t) {
    var i = n.call(
      e,
      {
        dispatch: r.dispatch,
        commit: r.commit,
        getters: r.getters,
        state: r.state,
        rootGetters: e.getters,
        rootState: e.state,
      },
      t,
    );
    return (
      te(i) || (i = Promise.resolve(i)),
      e._devtoolHook
        ? i.catch(function (t) {
            throw (e._devtoolHook.emit(`vuex:error`, t), t);
          })
        : i
    );
  });
}
function k(e, t, n, r) {
  e._wrappedGetters[t] ||
    (e._wrappedGetters[t] = function (e) {
      return n(r.state, r.getters, e.state, e.getters);
    });
}
function A(e) {
  r(
    function () {
      return e._state.data;
    },
    function () {},
    {
      deep: !0,
      flush: `sync`,
    },
  );
}
function j(e, t) {
  return t.reduce(function (e, t) {
    return e[t];
  }, e);
}
function M(e, t, n) {
  return (
    y(e) && e.type && ((n = t), (t = e), (e = e.type)),
    {
      type: e,
      payload: t,
      options: n,
    }
  );
}
var N = `vuex bindings`,
  P = `vuex:mutations`,
  F = `vuex:actions`,
  I = `vuex`,
  L = 0;
function R(e, t) {
  g(
    {
      id: `org.vuejs.vuex`,
      app: e,
      label: `Vuex`,
      homepage: `https://next.vuex.vuejs.org/`,
      logo: `https://vuejs.org/images/icons/favicon-96x96.png`,
      packageName: `vuex`,
      componentStateTypes: [N],
    },
    function (n) {
      (n.addTimelineLayer({
        id: P,
        label: `Vuex Mutations`,
        color: z,
      }),
        n.addTimelineLayer({
          id: F,
          label: `Vuex Actions`,
          color: z,
        }),
        n.addInspector({
          id: I,
          label: `Vuex`,
          icon: `storage`,
          treeFilterPlaceholder: `Filter stores...`,
        }),
        n.on.getInspectorTree(function (n) {
          if (n.app === e && n.inspectorId === I)
            if (n.filter) {
              var r = [];
              (U(r, t._modules.root, n.filter, ``), (n.rootNodes = r));
            } else n.rootNodes = [H(t._modules.root, ``)];
        }),
        n.on.getInspectorState(function (n) {
          if (n.app === e && n.inspectorId === I) {
            var r = n.nodeId;
            (E(t, r),
              (n.state = W(
                K(t._modules, r),
                r === `root` ? t.getters : t._makeLocalGettersCache,
                r,
              )));
          }
        }),
        n.on.editInspectorState(function (n) {
          if (n.app === e && n.inspectorId === I) {
            var r = n.nodeId,
              i = n.path;
            (r !== `root` && (i = r.split(`/`).filter(Boolean).concat(i)),
              t._withCommit(function () {
                n.set(t._state.data, i, n.state.value);
              }));
          }
        }),
        t.subscribe(function (e, t) {
          var r = {};
          (e.payload && (r.payload = e.payload),
            (r.state = t),
            n.notifyComponentUpdate(),
            n.sendInspectorTree(I),
            n.sendInspectorState(I),
            n.addTimelineEvent({
              layerId: P,
              event: {
                time: Date.now(),
                title: e.type,
                data: r,
              },
            }));
        }),
        t.subscribeAction({
          before: function (e, t) {
            var r = {};
            (e.payload && (r.payload = e.payload),
              (e._id = L++),
              (e._time = Date.now()),
              (r.state = t),
              n.addTimelineEvent({
                layerId: F,
                event: {
                  time: e._time,
                  title: e.type,
                  groupId: e._id,
                  subtitle: `start`,
                  data: r,
                },
              }));
          },
          after: function (e, t) {
            var r = {},
              i = Date.now() - e._time;
            ((r.duration = {
              _custom: {
                type: `duration`,
                display: i + `ms`,
                tooltip: `Action duration`,
                value: i,
              },
            }),
              e.payload && (r.payload = e.payload),
              (r.state = t),
              n.addTimelineEvent({
                layerId: F,
                event: {
                  time: Date.now(),
                  title: e.type,
                  groupId: e._id,
                  subtitle: `end`,
                  data: r,
                },
              }));
          },
        }));
    },
  );
}
var z = 8702998,
  B = {
    label: `namespaced`,
    textColor: 16777215,
    backgroundColor: 6710886,
  };
function V(e) {
  return e && e !== `root` ? e.split(`/`).slice(-2, -1)[0] : `Root`;
}
function H(e, t) {
  return {
    id: t || `root`,
    label: V(t),
    tags: e.namespaced ? [B] : [],
    children: Object.keys(e._children).map(function (n) {
      return H(e._children[n], t + n + `/`);
    }),
  };
}
function U(e, t, n, r) {
  (r.includes(n) &&
    e.push({
      id: r || `root`,
      label: r.endsWith(`/`) ? r.slice(0, r.length - 1) : r || `Root`,
      tags: t.namespaced ? [B] : [],
    }),
    Object.keys(t._children).forEach(function (i) {
      U(e, t._children[i], n, r + i + `/`);
    }));
}
function W(e, t, n) {
  t = n === `root` ? t : t[n];
  var r = Object.keys(t),
    i = {
      state: Object.keys(e.state).map(function (t) {
        return {
          key: t,
          editable: !0,
          value: e.state[t],
        };
      }),
    };
  if (r.length) {
    var a = G(t);
    i.getters = Object.keys(a).map(function (e) {
      return {
        key: e.endsWith(`/`) ? V(e) : e,
        editable: !1,
        value: q(function () {
          return a[e];
        }),
      };
    });
  }
  return i;
}
function G(e) {
  var t = {};
  return (
    Object.keys(e).forEach(function (n) {
      var r = n.split(`/`);
      if (r.length > 1) {
        var i = t,
          a = r.pop();
        (r.forEach(function (e) {
          (i[e] ||
            (i[e] = {
              _custom: {
                value: {},
                display: e,
                tooltip: `Module`,
                abstract: !0,
              },
            }),
            (i = i[e]._custom.value));
        }),
          (i[a] = q(function () {
            return e[n];
          })));
      } else
        t[n] = q(function () {
          return e[n];
        });
    }),
    t
  );
}
function K(e, t) {
  var n = t.split(`/`).filter(function (e) {
    return e;
  });
  return n.reduce(
    function (e, r, i) {
      var a = e[r];
      if (!a) throw Error(`Missing module "` + r + `" for path "` + t + `".`);
      return i === n.length - 1 ? a : a._children;
    },
    t === `root` ? e : e.root._children,
  );
}
function q(e) {
  try {
    return e();
  } catch (e) {
    return e;
  }
}
var J = function (e, t) {
    ((this.runtime = t), (this._children = Object.create(null)), (this._rawModule = e));
    var n = e.state;
    this.state = (typeof n == `function` ? n() : n) || {};
  },
  Y = {
    namespaced: {
      configurable: !0,
    },
  };
((Y.namespaced.get = function () {
  return !!this._rawModule.namespaced;
}),
  (J.prototype.addChild = function (e, t) {
    this._children[e] = t;
  }),
  (J.prototype.removeChild = function (e) {
    delete this._children[e];
  }),
  (J.prototype.getChild = function (e) {
    return this._children[e];
  }),
  (J.prototype.hasChild = function (e) {
    return e in this._children;
  }),
  (J.prototype.update = function (e) {
    ((this._rawModule.namespaced = e.namespaced),
      e.actions && (this._rawModule.actions = e.actions),
      e.mutations && (this._rawModule.mutations = e.mutations),
      e.getters && (this._rawModule.getters = e.getters));
  }),
  (J.prototype.forEachChild = function (e) {
    v(this._children, e);
  }),
  (J.prototype.forEachGetter = function (e) {
    this._rawModule.getters && v(this._rawModule.getters, e);
  }),
  (J.prototype.forEachAction = function (e) {
    this._rawModule.actions && v(this._rawModule.actions, e);
  }),
  (J.prototype.forEachMutation = function (e) {
    this._rawModule.mutations && v(this._rawModule.mutations, e);
  }),
  Object.defineProperties(J.prototype, Y));
var X = function (e) {
  this.register([], e, !1);
};
((X.prototype.get = function (e) {
  return e.reduce(function (e, t) {
    return e.getChild(t);
  }, this.root);
}),
  (X.prototype.getNamespace = function (e) {
    var t = this.root;
    return e.reduce(function (e, n) {
      return ((t = t.getChild(n)), e + (t.namespaced ? n + `/` : ``));
    }, ``);
  }),
  (X.prototype.update = function (e) {
    Z([], this.root, e);
  }),
  (X.prototype.register = function (e, t, n) {
    var r = this;
    n === void 0 && (n = !0);
    var i = new J(t, n);
    (e.length === 0 ? (this.root = i) : this.get(e.slice(0, -1)).addChild(e[e.length - 1], i),
      t.modules &&
        v(t.modules, function (t, i) {
          r.register(e.concat(i), t, n);
        }));
  }),
  (X.prototype.unregister = function (e) {
    var t = this.get(e.slice(0, -1)),
      n = e[e.length - 1],
      r = t.getChild(n);
    r && r.runtime && t.removeChild(n);
  }),
  (X.prototype.isRegistered = function (e) {
    var t = this.get(e.slice(0, -1)),
      n = e[e.length - 1];
    return t ? t.hasChild(n) : !1;
  }));
function Z(e, t, n) {
  if ((t.update(n), n.modules))
    for (var r in n.modules) {
      if (!t.getChild(r)) return;
      Z(e.concat(r), t.getChild(r), n.modules[r]);
    }
}
function ne(e) {
  return new Q(e);
}
var Q = function (e) {
    var t = this;
    e === void 0 && (e = {});
    var n = e.plugins;
    n === void 0 && (n = []);
    var r = e.strict;
    r === void 0 && (r = !1);
    var i = e.devtools;
    ((this._committing = !1),
      (this._actions = Object.create(null)),
      (this._actionSubscribers = []),
      (this._mutations = Object.create(null)),
      (this._wrappedGetters = Object.create(null)),
      (this._modules = new X(e)),
      (this._modulesNamespaceMap = Object.create(null)),
      (this._subscribers = []),
      (this._makeLocalGettersCache = Object.create(null)),
      (this._scope = null),
      (this._devtools = i));
    var a = this,
      o = this,
      s = o.dispatch,
      c = o.commit;
    ((this.dispatch = function (e, t) {
      return s.call(a, e, t);
    }),
      (this.commit = function (e, t, n) {
        return c.call(a, e, t, n);
      }),
      (this.strict = r));
    var l = this._modules.root.state;
    (w(this, l, [], this._modules.root),
      C(this, l),
      n.forEach(function (e) {
        return e(t);
      }));
  },
  $ = {
    state: {
      configurable: !0,
    },
  };
((Q.prototype.install = function (e, t) {
  (e.provide(t || `store`, this),
    (e.config.globalProperties.$store = this),
    this._devtools !== void 0 && this._devtools && R(e, this));
}),
  ($.state.get = function () {
    return this._state.data;
  }),
  ($.state.set = function (e) {}),
  (Q.prototype.commit = function (e, t, n) {
    var r = this,
      i = M(e, t, n),
      a = i.type,
      o = i.payload;
    i.options;
    var s = {
        type: a,
        payload: o,
      },
      c = this._mutations[a];
    c &&
      (this._withCommit(function () {
        c.forEach(function (e) {
          e(o);
        });
      }),
      this._subscribers.slice().forEach(function (e) {
        return e(s, r.state);
      }));
  }),
  (Q.prototype.dispatch = function (e, t) {
    var n = this,
      r = M(e, t),
      i = r.type,
      a = r.payload,
      o = {
        type: i,
        payload: a,
      },
      s = this._actions[i];
    if (s) {
      try {
        this._actionSubscribers
          .slice()
          .filter(function (e) {
            return e.before;
          })
          .forEach(function (e) {
            return e.before(o, n.state);
          });
      } catch {}
      var c =
        s.length > 1
          ? Promise.all(
              s.map(function (e) {
                return e(a);
              }),
            )
          : s[0](a);
      return new Promise(function (e, t) {
        c.then(
          function (t) {
            try {
              n._actionSubscribers
                .filter(function (e) {
                  return e.after;
                })
                .forEach(function (e) {
                  return e.after(o, n.state);
                });
            } catch {}
            e(t);
          },
          function (e) {
            try {
              n._actionSubscribers
                .filter(function (e) {
                  return e.error;
                })
                .forEach(function (t) {
                  return t.error(o, n.state, e);
                });
            } catch {}
            t(e);
          },
        );
      });
    }
  }),
  (Q.prototype.subscribe = function (e, t) {
    return x(e, this._subscribers, t);
  }),
  (Q.prototype.subscribeAction = function (e, t) {
    return x(
      typeof e == `function`
        ? {
            before: e,
          }
        : e,
      this._actionSubscribers,
      t,
    );
  }),
  (Q.prototype.watch = function (e, t, n) {
    var i = this;
    return r(
      function () {
        return e(i.state, i.getters);
      },
      t,
      Object.assign({}, n),
    );
  }),
  (Q.prototype.replaceState = function (e) {
    var t = this;
    this._withCommit(function () {
      t._state.data = e;
    });
  }),
  (Q.prototype.registerModule = function (e, t, n) {
    (n === void 0 && (n = {}),
      typeof e == `string` && (e = [e]),
      this._modules.register(e, t),
      w(this, this.state, e, this._modules.get(e), n.preserveState),
      C(this, this.state));
  }),
  (Q.prototype.unregisterModule = function (e) {
    var t = this;
    (typeof e == `string` && (e = [e]),
      this._modules.unregister(e),
      this._withCommit(function () {
        var n = j(t.state, e.slice(0, -1));
        delete n[e[e.length - 1]];
      }),
      S(this));
  }),
  (Q.prototype.hasModule = function (e) {
    return (typeof e == `string` && (e = [e]), this._modules.isRegistered(e));
  }),
  (Q.prototype.hotUpdate = function (e) {
    (this._modules.update(e), S(this, !0));
  }),
  (Q.prototype._withCommit = function (e) {
    var t = this._committing;
    ((this._committing = !0), e(), (this._committing = t));
  }),
  Object.defineProperties(Q.prototype, $));
export { ee as n, ne as t };
